// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const GET_SPACE_SCAN_SETTINGS =
  "mondoo.policy.ExtendedHub.GetSpaceScanSettings";
